"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const verifiers_1 = require("../verifiers");
const selectors_1 = require("../selectors");
const constants_1 = require("../constants");
const formatDataForMutation_1 = require("./formatDataForMutation");
const errors_1 = require("../errors");
exports.formatFieldDataListItem = (type, data, { fieldSchema, schema, initialData }, options) => {
    let nextData = data;
    if (R.isNil(nextData)) {
        if (initialData && initialData.id) {
            return {
                data: { id: initialData.id },
                type: 'disconnect',
            };
        }
        if (typeof initialData === 'string') {
            return {
                data: { id: initialData },
                type: 'disconnect',
            };
        }
        return null;
    }
    if (typeof nextData === 'string') {
        return {
            data: { id: nextData },
            type: 'connect',
        };
    }
    if (typeof nextData.id === 'string' && type === constants_1.MUTATION_TYPE.CREATE) {
        return {
            data: { id: nextData.id },
            type: 'connect',
        };
    }
    // TODO: is it valid case?
    if (!R.isNil(nextData.length) && nextData.length === 0 && type === constants_1.MUTATION_TYPE.UPDATE) {
        return null;
    }
    const shouldUpdate = type === constants_1.MUTATION_TYPE.UPDATE && typeof nextData.id === 'string';
    const nextFormatDataForMutationType = shouldUpdate ? constants_1.MUTATION_TYPE.UPDATE : constants_1.MUTATION_TYPE.CREATE;
    if (verifiers_1.isRelationField(fieldSchema)) {
        const relationTableSchema = selectors_1.tablesListSelectors.getTableById(schema, fieldSchema.relation.refTable.id);
        if (!relationTableSchema) {
            throw new errors_1.SDKError(errors_1.ERROR_CODES.TABLE_NOT_FOUND, errors_1.PACKAGES.UTILS, `Relation table schema with ${fieldSchema.relation.refTable.id} id not found in schema.`);
        }
        nextData = formatDataForMutation_1.formatDataForMutation(nextFormatDataForMutationType, nextData, {
            tableName: relationTableSchema.name,
            schema,
            initialData,
        }, options);
    }
    if (verifiers_1.isFileField(fieldSchema)) {
        nextData = formatDataForMutation_1.formatDataForMutation(nextFormatDataForMutationType, nextData, {
            tableName: constants_1.SYSTEM_TABLES.FILES,
            schema,
            initialData,
        }, options);
    }
    if (shouldUpdate) {
        return {
            type: 'update',
            data: verifiers_1.isListField(fieldSchema) ? { data: nextData, filter: { id: data.id } } : R.dissoc('id', nextData),
        };
    }
    return {
        data: nextData,
        type: 'create',
    };
};
//# sourceMappingURL=formatFieldDataListItem.js.map